import {Injectable} from '@angular/core';
import {Http, Headers, RequestOptions} from '@angular/http';

import {AuthService} from './auth.service';
import {ConfigService} from './config.service';
import {LogService} from './log.service';

import * as uuid from 'uuid';


@Injectable()
export class VolunteerService {
	constructor(
		private http: Http,

		private authService: AuthService,
		private config: ConfigService,
		private log: LogService
	) {}


	sendApplication(application: any) {
		return new Promise( (resolve, reject) => {
			let accessToken = localStorage.getItem('auth-jwt');
			let headers = new Headers({'Authorization': 'Bearer ' + accessToken});
			headers.append('Content-Type', 'application/json');
			let options = new RequestOptions({ headers: headers });

			let userId = this.authService.userId;
			let payload = {
				applicationId: uuid.v4().replace(/-/g, ''),
				application: application
			};
			let body = JSON.stringify(payload);

			this.http.post(this.config.basePath + '/v0/volunteers/application', body, options)
				.toPromise()
				.then( (res) => {
					// let foo = res.json();

					// console.log(foo);
					// let bar: any = foo;
					resolve();
				})
				.catch((err) => {			// this is a Response object, with res.status === 401, for example
					this.log.error(err);
					reject();
				});
		});
	}

}



// WEBPACK FOOTER //
// /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/services/volunteer.service.ts